import axios from 'axios';

import { UnauthorizedType } from '../types/UnauthorizedType';
import { TranslationsResultType } from '../types/TranslationsResultType';
import headers from '../headers.json';

type SuccessType = {
  success: boolean;
  message: string;
  data: Array<TranslationsResultType>;
};

type PromiseType =
  | { data: TranslationsResultType; success: boolean }
  | { data: UnauthorizedType; success: boolean }
  | { data: null; success: boolean };

const GET_TRANSLATIONS = async (): Promise<PromiseType> => {
  try {
    const serverUrl = process.env.REACT_APP_SERVER_URL_BACKEND_API;
    if (!serverUrl) throw Error('Backend-URL not defined.');

    const url = `${serverUrl}/translations/`;

    const response = await axios.get<SuccessType | UnauthorizedType>(url, {
      headers: {
        ...headers,
      },
      withCredentials: true,
    });

    if (response.data.success) {
      return { success: true, data: response.data };
    }

    return { success: false, data: response.data };
  } catch (error) {
    console.error(error);

    return { success: false, data: null };
  }
};

export default GET_TRANSLATIONS;
